import axios from "axios";
import { PostItem } from "hc-entities";
import moment from "moment";
import { environment } from "../../environment";

export const PostService = () => {
  const castToPostObj = (res: any): PostItem[] => {
    try {
      const _postItems: PostItem[] = [];
      if (res && res.data && res.data.length) {
        res.data.map((p: any) => {
          _postItems.push(
            new PostItem({
              ...p,
              postSettings: p.postSettings[0],
              created: p.created
                ? moment(new Date(parseInt(p.created))).calendar()
                : p.created,
              modified: p.modified
                ? moment(new Date(parseInt(p.modified))).calendar()
                : p.modified,
            })
          );
          return p;
        });
      }
      return _postItems;
    } catch (err) {
      throw err;
    }
  };

  const post = async (postItem: any, isEdit?: boolean) => {
    try {
      const _postItem = new PostItem(postItem);
      const path = environment.contentUrl + "publish?isEdit=" + isEdit;
      const res = await axios.post(path, _postItem);
      return res;
    } catch (err) {
      throw err;
    }
  };

  const quickPost = async (postItem: any, isEdit?: boolean) => {
    try {
      const _postItem = new PostItem(postItem);
      const path = environment.contentUrl + "posts/quick-post?isEdit=" + isEdit;
      const res = await axios.post(path, _postItem);
      return res;
    } catch (err) {
      throw err;
    }
  };

  const get = async () => {
    try {
      const path = environment.contentUrl + "posts";
      const res = await axios.get(path);
      return castToPostObj(res);
    } catch (err) {
      throw err;
    }
  };

  const getPostsByContentId = async (id: any): Promise<PostItem[]> => {
    try {
      const path = environment.contentUrl + "posts/content/" + id;
      const res = await axios.get(path);
      return castToPostObj(res);
    } catch (err) {
      throw err;
    }
  };

  const getPostsByEventId = async (id: any): Promise<PostItem[]> => {
    try {

      const path = environment.contentUrl + "posts/event/" + id;
      const res = await axios.get(path);
      return castToPostObj(res);
    } catch (err) {
      throw err;
    }
  };

  const editPost = async (post: any, id: string) => {
    try {
      const path = environment.contentUrl + "posts/" + id;
      const res = await axios.patch(path, post);
      return res;
    } catch (err) {
      throw err;
    }
  }

  return {
    post,
    getPostsByContentId,
    getPostsByEventId,
    get,
    quickPost,
    editPost
  };
};
